__turbopack_context__.v({
  "icon": "HeadlinesArticle-module-scss-module__c_aPbG__icon",
  "linkWithIcon": "HeadlinesArticle-module-scss-module__c_aPbG__linkWithIcon",
  "listItem": "HeadlinesArticle-module-scss-module__c_aPbG__listItem",
});
